import Mixin from '../Mixin';
import FDictionaryServiceAdditional from '@/modules/Dictionary/ServiceAdditional/Select';
import FDictionaryServiceDescription1 from '@/modules/Dictionary/ServiceDescription1/Select';
import FDictionaryServiceDescription2 from '@/modules/Dictionary/ServiceDescription2/Select';

import component from './component.vue';

export default class extends Mixin {
  component = component;

  additional = new FDictionaryServiceAdditional({
    label: '',
    required: true,
  });

  description1 = new FDictionaryServiceDescription1({
    label: 'Описание 1',
  });

  description2 = new FDictionaryServiceDescription2({
    label: 'Описание 2',
  });

  isCity = true;
  countCol = 1;
  constructor({ service = {}, ...props }) {
    super(props);
    this.service.set(service);
    this.additional.label = service.label;
    this.additional.service = this.service;
    this.additional.country = this.country;
    this.additional.city = this.city;
    this.setItem('additional', this.additional);
    if (!service.isCity) {
      this.isCity = false;
      this.deleteItem('city');
    } else {
      this.additional.city = this.city;
    }
    if (service.isID1) {
      this.description1.service = this.service;
      this.setItem('description1', this.description1);
      this.countCol += 1;
    }
    if (service.isID2) {
      this.description2.service = this.service;
      this.setItem('description2', this.description2);
      this.countCol += 1;
    }
  }

  set(value = {}) {
    super.set(value);
    this.__set('additional', value.additional, null);
    this.__set('description1', value.description1, null);
    this.__set('description2', value.description2, null);
    return this;
  }

  toString() {
    return this.additional.toString();
  }

  getIsCity(){
   return  this.isCity;
  }

  getCountCol(){
    return  this.countCol;
  }

  submit() {
    return super.submit()
      .then((data) => {
        this.name = this.additional.toLabel();
        return data;
      });
  }
}
